export const BrowserFrame = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="rounded-xl border border-border shadow-2xl overflow-hidden">
      {/* Chrome bar */}
      <div className="flex items-center gap-2 px-4 py-3 bg-muted/60 backdrop-blur-sm border-b border-border">
        {/* Traffic lights — macOS UI chrome convention (raw color values intentional per D-10) */}
        <div className="flex gap-1.5">
          <div className="w-3 h-3 rounded-full bg-red-400/80" />
          <div className="w-3 h-3 rounded-full bg-yellow-400/80" />
          <div className="w-3 h-3 rounded-full bg-green-400/80" />
        </div>
        {/* URL bar */}
        <div className="flex-1 mx-4">
          <div className="bg-background/60 rounded text-xs text-muted-foreground px-3 py-1 text-center">
            chytbot.com
          </div>
        </div>
      </div>
      {/* Content — children provide their own height. CLS guard is applied by the Hero wrapper, not here. */}
      {children}
    </div>
  );
};
